<mat-sidenav-container class="example-container">
  <mat-sidenav #drawer mode="side" opened role="navigation">
    <mat-nav-list
      *ngFor="let nav of menu; let index = index"
      (click)="handleClick(index)"
      [ngClass]="{ focusClass: selectedItem1 === nav.menu }"
    >
      <a mat-list-item (click)="navigate(nav)" id="{{ nav.menu }}">{{ nav.menu }}</a>
    </mat-nav-list>
  </mat-sidenav>
</mat-sidenav-container>
